import { createI18n } from "vue-i18n";
import * as Locales from "@utils/Locales.js";

const hasDocument = typeof document !== "undefined";

// Eagerly import all locale JSON at build time so messages are precompiled
// This avoids the runtime message-compiler (CSP-safe: no eval)
const files = import.meta.glob("@/locales/*.json", { eager: true });

// Build a messages map keyed by normalized app locale codes (e.g., 'en', 'fr', 'en-PI')
const messages = {};
for (const [p, mod] of Object.entries(files)) {
  const base = p.split("/").pop()?.replace(".json", "") || ""; // e.g. 'en-US'
  const code = base === "en-PI" ? "en-PI" : base.split("-")[0]; // map 'en-US' -> 'en'
  messages[code] = (mod && mod.default) || mod;
}

export const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  messages,
});

// Set language without dynamic imports (messages are already bundled)
export async function setLang(lang) {
  const normalized = Locales.normalizeLocale(lang) || "en";
  const target = i18n.global.availableLocales.includes(normalized)
    ? normalized
    : "en";
  i18n.global.locale.value = target;
  if (hasDocument) {
    document.documentElement.setAttribute("lang", target);
  }
}
